import React from "react";
import { useLocation, useNavigate, matchPath } from "react-router-dom";
import routes from "../../routes";
// CSS đã được hợp nhất vào App.css

interface MobileHeaderProps {
  title?: string;
  subtitle?: string;
  onBackPath?: string; // fallback path when history cannot go back
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ title, subtitle, onBackPath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { customerName?: string } | null;

  // Determine if current path is a root page where back button should be hidden
  const isRootPage = React.useMemo(() => {
    const path = location.pathname;
    return (
      matchPath({ path: "/admin/dashboard", end: true }, path) !== null ||
      matchPath({ path: "/admin/customers", end: true }, path) !== null ||
      matchPath({ path: "/admin/orders", end: true }, path) !== null ||
      matchPath({ path: "/admin/orders/add", end: true }, path) !== null
    );
  }, [location.pathname]);

  // Derive title from current route if not provided
  const derivedTitle = React.useMemo(() => {
    // Special case: customer edit/detail route
    if (matchPath({ path: "/admin/customers/:id", end: true }, location.pathname) ||
        matchPath({ path: "/staff/customers/:id", end: true }, location.pathname)) {
      return "Cập nhật khách hàng";
    }
    if (title) return title;
    const current = routes.find(r => {
      const pattern = r.layout + r.path;
      return matchPath({ path: pattern, end: false }, location.pathname) !== null;
    });
    return current?.name || "";
  }, [location.pathname, title]);

  const derivedSubtitle = React.useMemo(() => {
    // Special case subtitle for customer route using passed state
    if (matchPath({ path: "/admin/customers/:id", end: true }, location.pathname) ||
        matchPath({ path: "/staff/customers/:id", end: true }, location.pathname)) {
      if (state?.customerName) return `Khách hàng ${state.customerName}`;
      return "Khách hàng";
    }
    return subtitle;
  }, [location.pathname, state?.customerName, subtitle]);

  // Determine current route icon for root pages (align with BottomNavigation)
  const currentIconClass = React.useMemo(() => {
    const current = routes.find(r => {
      const pattern = r.layout + r.path;
      return matchPath({ path: pattern, end: false }, location.pathname) !== null;
    });
    // Fallback icon if not found
    return (current as any)?.icon || "fa fa-home";
  }, [location.pathname]);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else if (onBackPath) {
      navigate(onBackPath);
    } else {
      // Default fallbacks based on path
      if (location.pathname.includes("/customers")) {
        navigate("/admin/customers");
      } else if (location.pathname.includes("/orders")) {
        navigate("/admin/orders");
      } else {
        navigate("/admin/dashboard");
      }
    }
  };

  return (
    <div className="mobile-header d-lg-none">
      {!isRootPage ? (
        <button className="mobile-header__back" onClick={handleBack} aria-label="Quay lại">
          <i className="fa fa-arrow-left" style={{ fontSize: "2rem" }}></i>
        </button>
      ) : (
        <div className="mobile-header__back" aria-hidden="true">
          <i className={currentIconClass} style={{ fontSize: "2rem" }}></i>
        </div>
      )}
      <div className="mobile-header__titles">
        <div className="mobile-header__title">{derivedTitle}</div>
        {derivedSubtitle && <div className="mobile-header__subtitle">{derivedSubtitle}</div>}
      </div>
      <div className="mobile-header__spacer"></div>
    </div>
  );
};

export default MobileHeader;


